import axios from 'axios';
import { DPL_API_CONFIG } from '../config/apiConfig';

export async function fetchDplUndergradPrograms() {
  const api = `${DPL_API_CONFIG.baseUrl}/codeset/acad-plans?degreeType=UG&filter=activeInDegreeSearch&include=subplans&include=campusesOffered&include=acadPlanMarketingDescription`;
  console.log('api: ' + api);
  let res = [];

  await axios.get(api).then((response) => {
    res = response.data;
  });

  return res;
}

export async function fetchDplMinorsAndCertificates() {
  const api = `${DPL_API_CONFIG.baseUrl}/codeset/acad-plans?degreeType=UGCM&filter=activeInDegreeSearch&include=subplans&include=campusesOffered&include=acadPlanMarketingDescription`;
  console.log('api: ' + api);
  let res = [];

  await axios.get(api).then((response) => {
    res = response.data;
  });

  return res;
}

export async function fetchDplUndergradMinorsCertificates() {
  const api = `${DPL_API_CONFIG.baseUrl}/codeset/acad-plans?degreeType=UG&degreeType=UGCM&filter=activeInDegreeSearch&include=subplans&include=campusesOffered&include=acadPlanMarketingDescription`;
  console.log('api: ' + api);
  let res = [];

  await axios.get(api).then((response) => {
    res = response.data;
  });

  return res;
}

export async function fetchDplUndergradProgramsByAcadPlanCode(acadplan) {
  const api = `${DPL_API_CONFIG.baseUrl}/codeset/acad-plan/${acadplan}?include=subplans&include=campusesOffered&include=acadPlanMarketingDescription`;
  console.log('api: ' + api);
  let res = [];

  await axios.get(api).then((response) => {
    res = response.data;
    // console.log("fetchprograms res: ", res);
  });

  return res;
}

export async function fetchDplColleges() {
  const api = `${DPL_API_CONFIG.baseUrl}/codeset/colleges?include=childAcadOrgs`;
  console.log('api: ' + api);
  let res = [];

  await axios.get(api).then((response) => {
    res = response.data;
  });

  return res;
}

export async function fetchDplAllPrograms() {
  const api = `${DPL_API_CONFIG.baseUrl}/codeset/acad-plans`;
  console.log('api: ' + api);
  let res = [];

  await axios.get(api).then((response) => {
    res = response.data;
  });

  return res;
}

export async function fetchDplAllCourses(term) {
  const api = `${DPL_API_CONFIG.baseUrl}/course/${term}`;

  console.log('api: ' + api);
  let res = [];

  await axios.get(api).then((response) => {
    res = response.data;
  });

  return res;
}
